export const ru = {
    total_time: 'Общее время',
};
